import Image from "next/image";
import CTALink from "@/components/CTA/ctaLink";
import PromoBannerTooltip from "@/components/PromoBanner/components/PromoBannerTooltip";
import type { BasePromoBannerProps } from "@/components/PromoBanner/types";
import boldTextWithAsterisk from "@/utils/functions/boldTextWithAsterisk";
import { BadgeIcon } from "@/components/ui/badgeIcon";
import CopyButton from "@/components/CopyButton";

export default function PromoBannerSlimTagged({
  tagText,
  tagIcon,
  productType,
  title,
  description,
  discountCode,
  endDate,
  image,
  tooltip,
}: BasePromoBannerProps) {
  return (
    <div className="flex flex-col md:flex-row bg-primary rounded-xl">
      <div className="p-8 md:p-10 md:pl-14 md:basis-1/2 xl:basis-full">
        {(tagText || tagIcon || productType) && (
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4 mb-4">
            {(tagText || tagIcon) && (
              <div className="w-fit">
                <BadgeIcon
                  color="primaryLight"
                  withBorder={true}
                  icon={tagIcon || "none"}
                  iconSize={14}
                >
                  {tagText}
                </BadgeIcon>
              </div>
            )}
            {productType && (
              <span className="text-primary-foreground text-md">
                {productType}
              </span>
            )}
          </div>
        )}
        <h2 className="text-primary-foreground italic mt-0 mb-4 font-black text-[40px]">
          {title}
        </h2>
        <p className="hidden md:block text-primary-foreground mb-4 text-lg">
          {typeof description === "string"
            ? boldTextWithAsterisk(description)
            : description}{" "}
        </p>
        <div className="flex flex-col md:flex-row gap-4 items-start md:items-center">
          {discountCode && (
            <div className="[&_*]:no-underline">
              <CopyButton text={discountCode} buttonVariant="brand" size="sm" />
            </div>
          )}
          <div className="flex flex-row gap-1 items-center">
            <p className="text-primary-foreground elm-p3 mb-0 text-md">
              Ends {endDate}
            </p>
            <PromoBannerTooltip
              discountCode={discountCode}
              endDate={endDate}
              htmlContent={tooltip?.infoText ?? ""}
              size={16}
            />
          </div>
        </div>
      </div>
      {image?.url && (
        <div className="hidden md:block relative clip-slant-left basis-1/2">
          <Image
            src={image.url}
            alt={image.altText || ""}
            className="object-cover rounded-r-xl !mt-0"
            fill
          />
        </div>
      )}
    </div>
  );
}
